/**
 * final form の validate でエラーが発生した場合、エラーメッセージを表示する
 */
export const zodFinalFormValidate = (schema) => (values) => {
    // Zod schema を使用して値をバリデート
    const result = schema.safeParse(values);
    // エラーがない場合は空のオブジェクトを返す
    if (result.success) {
        return {};
    }
    // エラーがある場合はエラーメッセージを返す
    return result.error.issues.reduce((prev, issue) => (Object.assign(Object.assign({}, prev), { [issue.path.join('.')]: issue.message })), {});
};
